export default {
    individual: 'หน้าข้อความรายบุคคล',
    createMessage: 'สร้างข้อความ',
    startDate: 'วันที่เริ่ม',
    endDate: 'วันที่สิ้นสุด',
    topic: 'หัวข้อ',
    employeeNo: 'รหัสพนักงาน',
    employeeName: 'ชื่อ - นามสกุล',
    searchByTopicOrEmployeeNo: 'ค้นหาตามหัวข้อหรือรหัสพนักงาน',
    search: 'ค้นหา',
    deleteMessage: 'ลบข้อความ',
    congratulation: 'ยินดีด้วย',
    msgDeleteSuccess: 'ข้อความรายบุลคลถูกลบเเล้ว',
    questionDelete: 'คุณเเน่ใจว่าต้องการที่จะลบข้อความ "$Name" ?'
}
